import { FilterPill } from 'types/srpFilters';
import { FilterPillFn } from 'components/Srp/FilterPills/hooks/useCreateFilterPills';

function createResetState(key: string): Record<string, any> {
  return {
    MakeModel: {
      [key]: undefined,
      ...(key === 'make' && { model: undefined }),
    },
    Trims: [],
  };
}

export default function useMakeModelFilterPillsCreators(): FilterPillFn {
  return (makeModelFilters: { [key: string]: string }): FilterPill[] => {
    return Object.entries(makeModelFilters)
      .filter(([, value]) => Boolean(value))
      .map(([key, value]) => ({
        name: key,
        label: value,
        resetState: createResetState(key),
      }));
  };
}
